import React, { useEffect, useState } from "react";
import api from "../../axiosConfig";
import { Table, Button, Container, Row, Col, Form } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import ReactPaginate from "react-paginate";
import "../pagination.css";

const CasariList = () => {
  const [items, setItems] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(0);
  const [search, setSearch] = useState("");
  const itemsPerPage = 10;
  const navigate = useNavigate();

  const fetchItems = async () => {
    try {
      const res = await api.get("/obinv/casare/", {
        params: {
          offset: currentPage * itemsPerPage,
          limit: itemsPerPage,
          search: search,
        },
      });
      setItems(res.data.items || []);
      setTotalCount(res.data.total || 0);
    } catch (error) {
      console.error("Error fetching casari:", error);
    }
  };

  useEffect(() => {
    fetchItems();
  }, [currentPage, search]);

  const handlePageClick = (data) => {
    setCurrentPage(data.selected);
  };

  const deleteItem = async (id) => {
    if (window.confirm("Sigur ștergeți acest document?")) {
      await api.delete(`/obinv/casare/${id}`);
      fetchItems();
    }
  };

  return (
    <Container className="mt-4">
      <Row className="mb-3">
        <Col>
          <h2>Casări Ob. Inv.</h2>
        </Col>
        <Col md={4}>
          <Form.Control
            type="text"
            placeholder="Căutare document..."
            value={search}
            onChange={(e) => {
              setSearch(e.target.value);
              setCurrentPage(0);
            }}
          />
        </Col>
        <Col className="text-end">
          <Button variant="danger" onClick={() => navigate("/obinv/casare/new")}>+ Adaugă Casare</Button>
        </Col>
      </Row>

      <Table striped bordered hover>
        <thead>
          <tr>
            <th>Nr. Doc</th>
            <th>Data</th>
            <th>Angajat</th>
            <th>Motiv</th>
            <th>Acțiuni</th>
          </tr>
        </thead>
        <tbody>
          {items.map((item) => (
            <tr key={item.id}>
              <td>{item.doc_no}</td>
              <td>{item.doc_date}</td>
              <td>{item.angajat_nume}</td>
              <td>{item.motiv}</td>
              <td>
                <Button
                  variant="primary"
                  size="sm"
                  className="me-2"
                  onClick={() => navigate(`/obinv/casare/edit/${item.id}`)}
                >
                  Modifică
                </Button>
                <Button
                  variant="danger"
                  size="sm"
                  onClick={() => deleteItem(item.id)}
                >
                  Șterge
                </Button>
              </td>
            </tr>
          ))}
          {items.length === 0 && (
            <tr>
              <td colSpan="5" className="text-center">Nu există înregistrări.</td>
            </tr>
          )}
        </tbody>
      </Table>
      {totalCount > itemsPerPage && (
        <ReactPaginate
          previousLabel={"Înapoi"}
          nextLabel={"Înainte"}
          breakLabel={"..."}
          pageCount={Math.ceil(totalCount / itemsPerPage)}
          marginPagesDisplayed={2}
          pageRangeDisplayed={3}
          onPageChange={handlePageClick}
          containerClassName={"pagination justify-content-center"}
          pageClassName={"page-item"}
          pageLinkClassName={"page-link"}
          previousClassName={"page-item"}
          previousLinkClassName={"page-link"}
          nextClassName={"page-item"}
          nextLinkClassName={"page-link"}
          breakClassName={"page-item"}
          breakLinkClassName={"page-link"}
          activeClassName={"active"}
          forcePage={currentPage}
        />
      )}
    </Container>
  );
};

export default CasariList;
